/**
 * PAC-07 — busca de pacientes por «Nome, CPF ou telefone» (também e-mail e tags) e a lista
 * «Recentes» do computador. Regra única para a página Pacientes e a lista ao lado da ficha.
 */
import type { Patient } from '@/entities/patient/types'
import { includesNormalized } from '@/shared/lib/normalize'

const digitsOf = (value: string | undefined) => (value ?? '').replace(/\D/g, '')

export function matchesPatientQuery(patient: Patient, query: string): boolean {
  const trimmed = query.trim()
  if (!trimmed) return true
  const text = `${patient.name} ${patient.documentNumber ?? ''} ${patient.email ?? ''} ${(patient.tags ?? []).join(' ')}`
  if (includesNormalized(text, trimmed)) return true
  // CPF e telefone: compara só dígitos, com ou sem máscara («123.456», «98765-4421»).
  const queryDigits = digitsOf(trimmed)
  if (queryDigits.length < 3) return false
  return digitsOf(patient.documentNumber).includes(queryDigits) || digitsOf(patient.phone).includes(queryDigits)
}

/** Mais recentes primeiro (última atividade ou criação). */
export function sortPatientsByRecent(patients: ReadonlyArray<Patient>): Patient[] {
  const at = (patient: Patient) => new Date(patient.updatedAt ?? patient.createdAt).getTime() || 0
  return [...patients].sort((left, right) => at(right) - at(left))
}
